import React, { useEffect, useState, useRef } from 'react';
import Styled from 'styled-components';
import { device, breakpoints, getWidthRange } from '../../../../app/js/utils/responsive_utilities';
import { fontQuicksand } from '../../common/mixins/mixin';
import { deepCoveDark, white } from '../../../../app/js/components/loggedout/shared-styles/Colors';
import PlansSection from './Plans';
import { melaDurationMap, computePricingInfo } from '../../../../app/js_bytesize/templates/purchase/pricing-helper';
import { durationListForSorting } from '../../../../app/js/utils/web-helper';

function ProductList({ products, settings }) {
  const subjectCodeMap = {
    Math: 'math',
    Maths: 'math',
    Reading: 'ela',
    'Math + Reading': 'mela',
    'Maths + Reading': 'mela',
    'Books': 'book',
    'Book': 'book',
    'Math, Reading and Live Classes': 'mela',
    'Math + Reading + Live Classes': 'mela',
    'Maths, Reading and Live Classes': 'mela',
    'Maths + Reading + Live Classes': 'mela',
    'Math, Reading, Books and Live Classes': 'all_inclusive',
    'Math + Reading + Books + Live Classes': 'all_inclusive',
    'Maths, Reading, Books and Live Classes': 'all_inclusive',
    'Maths + Reading + Books + Live Classes': 'all_inclusive',
  }
  const subjectFilterList = ['mela', 'math', 'ela', 'book', 'all_inclusive']; // for maintaining the order of subjects in products
  let productsBySubject = new Map();
  const displayNames = {};
  const durationList = new Set();
  let { currency_code = 'USD' } = products && products.length && products[0];

  products.forEach(element => {
    productsBySubject.set(subjectCodeMap[element.properties.display_name], new Map());
    displayNames[subjectCodeMap[element.properties.display_name]] = element.properties.display_name;
    durationList.add(melaDurationMap[element.access_duration]);
  })

  products.forEach((element) => {
    productsBySubject.get(subjectCodeMap[element.properties.display_name]).set(melaDurationMap[element.access_duration], []);
  })

  products.forEach((element) => {
    productsBySubject.get(subjectCodeMap[element.properties.display_name]).get(melaDurationMap[element.access_duration]).push(element);
  })

  const filterTabMap = [];
  subjectFilterList.forEach((val) => {
    if (Object.keys(displayNames).indexOf(val) > -1) {
      filterTabMap.push({
        id: val,
        title: displayNames[val]
      })
    }
  })

  const sortedDurationList = durationListForSorting.filter(val => durationList.has(val));
  const activeFilterTabId = useRef(filterTabMap.length && filterTabMap[0].id);
  const [activeFilterTab, setActiveFilterTab] = useState(filterTabMap[0])
  const filterTabHandler = (val) => {
    if(val){
      trackAnalyticsEvent("Interacted All Plans Page", { 'Interaction Details': `Changed Subject to ${val.id == "mela" ? "Math and Reading" : val.title}` });
      setActiveFilterTab(val)
    }
  }

  const [preferredPlanSaving, setPreferredPlanSaving] = useState(null);
  useEffect(() => {
    trackAnalyticsEvent('Viewed Purchase Page', window.purchasePageEventData);
    if (products.length && sortedDurationList.length > 1) {
      let planProduct = productsBySubject.get(filterTabMap[0].id);
      let yearlyPriceInfo = computePricingInfo(planProduct.get(sortedDurationList[0])[0], settings);
      let quarterlyPriceInfo = computePricingInfo(planProduct.get(sortedDurationList[1])[0], settings);
      let planSaving = Math.floor(Math.abs(((yearlyPriceInfo.actualMonthlyPrice / quarterlyPriceInfo.actualMonthlyPrice) - 1) * 100));
      setPreferredPlanSaving(planSaving);
    }
  }, []);

  useEffect(() => {
    activeFilterTabId.current = filterTabMap.length && filterTabMap[0].id;
  })

  if (activeFilterTabId.current != (filterTabMap.length && filterTabMap[0].id)) {
    activeFilterTabId.current = filterTabMap[0].id;
    setActiveFilterTab(filterTabMap[0])
  }

  return (
    <PurchaseBody className='purchase-body'>
      <PlanWrapper className='plans-wrapper'>
        {!!products.length && activeFilterTab ? <PlansSection
          products={productsBySubject.get(activeFilterTab && activeFilterTab.id)}
          activeFilterTab={activeFilterTab}
          filterTabList={filterTabMap}
          filterTabHandler={filterTabHandler}
          productsBySubject={productsBySubject}
          sortedDurationList={sortedDurationList}
          preferredPlanSaving={preferredPlanSaving}
          settings={settings}
        /> : <h1>Some Error!</h1>}
        {/* <CurrencyInfo>*All prices in {currency_code}</CurrencyInfo> */}
      </PlanWrapper>
    </PurchaseBody>
  )
}

export default ProductList;

export const PurchaseBody = Styled.div`
  display: flex;
  width: 100%;
  overflow: hidden;
`;

export const PlanWrapper = Styled.div`
  background-color: ${deepCoveDark};
  color: ${white};
  text-align: center;
  width: 75%;
  overflow-y: auto;
  margin: 2rem auto;
  @media ${device.Phone} {
    width: 94%;
  }
  @media ${device.PhoneLandscape} {
    width: 70%;
  }
  @media ${getWidthRange(767, 1025)} and (orientation: portrait) {
    width: 80%;
  }
  @media (min-width: ${breakpoints.lg}px) {
    width: 56.71%;
    margin: auto;
  }

  @media ${device.TabletLandscape}{
    width: 85%;
  }

`;

export const CurrencyInfo = Styled.p`
  text-align: left;
  margin: 0 0 0 1rem;
  position: fixed;
  bottom: 0.8rem;
  ${fontQuicksand(1.2, 1.6, 5)};
  @media ${device.Phone} {
    position: unset;
    margin-bottom: 1rem;
    margin-top: 1rem;
    text-align: center;
  }
  @media ${getWidthRange(767, 1025)} and (orientation: portrait) {
    position: unset;
    text-align: center;
  }
`;
// Move code from js_bytesize to js
// The new plan page should be independent of the old one [web & mobile]
// Upgrade we will use existing code